import React, { useEffect } from 'react';
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';

import { useDispatch } from 'react-redux';

import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import Requests from '../Requests/Requests';
import AboutPage from '../AboutPage/AboutPage';
import LandingPage from '../LandingPage/LandingPage';
import LoginPage from '../LoginPage/LoginPage';
import RegisterPage from '../RegisterPage/RegisterPage';
import ReferralLandingPage from '../ReferralLandingPage/ReferralLandingPage';
import ReferralFormTab from '../ReferralFormTab/ReferralFormTab';
import ReferralComplete from '../ReferralComplete/ReferralComplete';
import Admin from '../Admin/Admin';
import {useSelector} from 'react-redux';
import './App.css';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'FETCH_USER' });
  }, [dispatch]);
  const user = useSelector((store) => store.user);
  return (
    <Router>

{/*
        <Nav /> 
*/}

        <Switch>
          {/* Visiting localhost:3000 will redirect to localhost:3000/home */}
          <Redirect exact from="/" to="/home" />
          {/* Visiting localhost:3000/about will show the about page. */}
          <Route
            // shows AboutPage at all times (logged in or not)
            exact
            path="/referralTab"
          >
            <ReferralFormTab />
          </Route>
          <ProtectedRoute
            path="/admin"
          >
            <Admin />
          </ProtectedRoute>

          <Route
            // shows AboutPage at all times (logged in or not)
            exact
            path="/about"
          >
            <AboutPage />
          </Route>

          {/* For testing referral form. Route will be moved when referral passwords are made.*/}
          <Route
            path="/referralform/:id"
          >
            <ReferralLandingPage />
          </Route>


            <Route
            path="/referralcomplete"
          >
            <ReferralComplete />
          </Route>
          {/* For protected routes, the view could show one of several things on the same route.
            Visiting localhost:3000/user will show the UserPage if the user is logged in.
            If the user is not logged in, the ProtectedRoute will show the LoginPage (component).
            Even though it seems like they are different pages, the user is always on localhost:3000/user */}
          <ProtectedRoute
            // logged in shows UserPage else shows LoginPage
            exact
            path="/admin/requests"
          >
            <Requests />
          </ProtectedRoute>

          {/* When a value is supplied for the authRedirect prop the user will
            be redirected to the path supplied when logged in, otherwise they will
            be taken to the component and path supplied. */}
          <ProtectedRoute
            // with authRedirect:
            // - if logged in, redirects to "/user"
            // - else shows LoginPage at /login
            exact
            path="/login"
            authRedirect="/admin/requests"
          >
            <LoginPage />
          </ProtectedRoute>
          <ProtectedRoute
            // with authRedirect:
            // - if logged in, redirects to "/user"
            // - else shows RegisterPage at "/registration"
            exact
            path="/registration"
            authRedirect="/admin/requests"
          >
            <RegisterPage />
          </ProtectedRoute>

          <ProtectedRoute
            // with authRedirect:
            // - if logged in, redirects to "/admin/requests"
            // - else shows LandingPage at "/home"
            exact
            path="/home"
            authRedirect="/admin/requests"
          >
            <LandingPage />
          </ProtectedRoute>

          {/* If none of the other routes matched, we will show a 404. */}
          <Route>
            <h1>404</h1>
          </Route>
        </Switch>
    </Router>
  );
}

export default App;
